<template>
    <div>
        <div class="toptitle">就业项目</div>
        <div class="topcont">
            <div>
                <div class="flex-between">
                    <div>按月份 累计</div>
                    <div class=" flex-between point" style="position: relative;">
                        <div @click="showDate = !showDate" class="flex datebox">
                            <div>{{ chooseDate.year }}-{{ chooseDate.mouth }}</div>
                            <i class="el-icon-caret-bottom"></i>
                        </div>
                        <div v-show="showDate" class="datechoosebox">
                            <div class="flex-center">
                                <i @click="prevYear" class="el-icon-d-arrow-left point"></i>
                                <div class="cutyear">{{ chooseDate.year }}</div>
                                <i @click="nextYear" class="el-icon-d-arrow-right point"></i>
                            </div>
                            <div class="flex" style="flex-wrap: wrap;">
                                <div @click="cliMouth(index)" class="mouthone" v-for="(item, index) in mouthList"
                                    :key="index">{{ item }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 菜单 -->
                <div class="flex-around" style="margin-top: 16px;">
                    <div @click="changeType(2)" :class="active == 2 ? 'typeactive' : ''" class="typeone">已完成{{
                        typeNumbers.ywc }}</div>
                    <div @click="changeType(1)" :class="active == 1 ? 'typeactive' : ''" class="typeone">进行中{{
                        typeNumbers.jxz }}</div>
                    <div @click="changeType(0)" :class="active == 0 ? 'typeactive' : ''" class="typeone">待开工{{
                        typeNumbers.dkg }}</div>
                </div>
                <!-- 列表 -->
                <div v-if="jiuyeList.length" style="margin-top: 14px;">
                    <div v-for="item in jiuyeList" :key="item.id" class="flex-between fone point">
                        <div>{{ item.job_title }}</div>
                        <div class="flex">
                            <div class="pernum">({{ item.number }}人)</div>
                            <i class="el-icon-caret-right"></i>
                        </div>
                    </div>
                </div>
                <empty v-else :size="140" text="暂无项目"></empty>

            </div>
            <div style="margin-top: 10px;justify-content: flex-end;" class="flex">
                <el-pagination layout="prev, pager, next" @current-change="pageChange" :total="total"
                    :current-page="page" :page-size="4" background>
                </el-pagination>
            </div>
        </div>


    </div>
</template>
<script>
import empty from "@/components/empty/empty.vue"
export default {
    components: {
        empty
    },
    data() {
        return {
            active: 2,
            showDate: false,
            mouthList: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            chooseDate: {
                year: new Date().getFullYear(),
                mouth: new Date().getMonth() + 1
            },
            page: 1,
            total: 0,
            jiuyeList: [],
            typeNumbers: {
                dkg: 0,
                jxz: 0,
                ywc: 0,
            }
        }
    },
    mounted() {
        this.getJiuyeList()
    },
    methods: {
        pageChange(e) {
            console.log(e, "eee")
            this.page = e
            this.getJiuyeList()
        },
        // 获取就业项目
        getJiuyeList() {
            this.$api({
                url: '/api/central_control/employment_projects',
                method: 'POST',
                data: {
                    page: this.page,
                    pagesize: 4,
                    time: `${this.chooseDate.year}-${this.chooseDate.mouth}`,
                    work_status: this.active
                },
            }).then(res => {
                console.log(res.data, "resresres")
                this.jiuyeList = res.data.list.data
                this.total = res.data.list.total
                this.typeNumbers = {
                    dkg: res.data.dkg,
                    jxz: res.data.jxz,
                    ywc: res.data.ywc,
                }
            })
        },
        changeType(num) {
            this.active = num
            this.page = 1
            this.getJiuyeList()
        },
        cliMouth(index) {
            let a = index + 1
            this.chooseDate.mouth = a < 10 ? '0' + a : a
            this.page = 1
            this.getJiuyeList()
            this.showDate = false
        },
        prevYear() {
            this.chooseDate.year = --this.chooseDate.year
            this.page = 1
            this.getJiuyeList()

        },
        nextYear() {
            this.chooseDate.year = ++this.chooseDate.year
            this.page = 1
            this.getJiuyeList()

        },
    }
}
</script>
<style lang="less" scoped>
.fone {
    height: 40px;
    font-size: 13px;
    color: #eee;
    padding: 0 30px 0 10px;

    .pernum {
        margin-right: 15px;
    }

    &:nth-child(2n+2) {
        background: #082667;
    }
}

.typeone {
    font-weight: 400;
    font-size: 16px;
    color: #BABABA;
    padding: 7px 30px;
    cursor: pointer;
}

.typeactive {
    background: url('@/assets/kaigongtype.png') no-repeat 100%;

}

.topcont {
    background: url('@/assets/conbg.png') no-repeat 0 0/100% 100%;
    width: 100%;
    // height: 100%;
    height: calc(((100vh - 100px) / 2) - 50px);
    // max-height: 385px;
    padding: 16px 26px 20px;
    box-sizing: border-box;
    color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;


}


.datechoosebox {
    position: absolute;
    background: #041852;
    top: 33px;
    right: 0;
    // height: 33px;
    width: 400px;
    padding: 30px 0;
    box-sizing: border-box;

    .mouthone {
        font-size: 18px;
        margin: 20px;
        width: 80px;
        text-align: center;

        &:hover {
            background: #082667;
        }
    }

    .cutyear {
        margin: 0 30px;
        font-size: 20px;
        font-weight: 700;

    }

}

::v-deep {
    .number {
        background: transparent !important;
    }

    .active {
        background: #16367B !important;
    }

    .btn-prev {
        background: transparent !important;
    }

    .btn-next {
        background: transparent !important;
    }
}
</style>